import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=def3037a&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"
import style0 from "./FullScreenModal.vue?vue&type=style&index=0&id=def3037a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def3037a",
  null
  
)

export default component.exports